import { render, staticRenderFns } from "./SetPasswordDialog.vue?vue&type=template&id=870b1b62"
import script from "./SetPasswordDialog.vue?vue&type=script&lang=js"
export * from "./SetPasswordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports